import { LIBRA_STATUS, TRANSFER_MODE } from '@constants';

export const TAB_STATES = {
  ACCOUNTS: 'ACCOUNTS',
  TRANSFERS: 'TRANSFERS',
  CORPORATE_BENEFICIARIES: 'CORPORATE BENEFICIARIES',
  SCHEDULED_TRANSFERS: 'SCHEDULED TRANSFERS'
};

export const PARTNER_OPTIONS = [
  { value: 'CLEARBANK', label: 'CLEARBANK' },
  { value: 'TRUELAYER', label: 'TRUELAYER' },
  { value: 'CHECKOUT',  label: 'CHECKOUT'  }
];

export const CURRENCY_OPTIONS = [
  { value: 'GBP', label: 'GBP' },
  { value: 'EUR', label: 'EUR' },
  { value: 'USD', label: 'USD' }
];

export const ACCOUNT_TYPE_OPTIONS = [
  { value: 'safeguarding', label: 'Safeguarding' },
  { value: 'operating', label: 'Operating' },
  { value: 'merchant', label: 'Merchant' }
];

export const TRANSFER_TYPE_OPTIONS = [
  { value: 'FPS', label: 'FPS' },
  { value: 'CHAPS', label: 'CHAPS' },
  { value: 'SEPA', label: 'SEPA' },
  { value: 'SWIFT', label: 'SWIFT' },
  { value: 'ACH', label: 'ACH' },
  { value: 'WIRE', label: 'WIRE' },
  { value: 'COLUMN_COUNTERPARTY', label: 'COLUMN COUNTERPARTY' }
];

// Status options shown in the Transfers tab filter dropdown.
// "All" is rendered separately by the component (it's not a real status).
export const TRANSFER_STATUS_FILTER_OPTIONS = [
  { value: LIBRA_STATUS.OPEN, label: 'Open' },
  { value: LIBRA_STATUS.PROCESSING, label: 'Processing' },
  { value: LIBRA_STATUS.COMPLETED, label: 'Completed' },
  { value: LIBRA_STATUS.FAILED, label: 'Failed' }
];

// Mode options shown in the Transfers tab filter dropdown. Mirrors the
// `mode` field on every transfer row (see Mode column in tableColumns.jsx).
export const TRANSFER_MODE_FILTER_OPTIONS = [
  { label: 'Sweepout', value: 'SWEEPOUT' },
  { label: 'One time', value: 'ONE_TIME' },
  { label: 'Scheduled', value: 'SCHEDULED' }
];

// Debounce window for the Transfers search input. Mirrors the
// OutboundCalling AdminDashboard cadence (500ms) — long enough to avoid a
// fetch on every keystroke, short enough that the user feels the result is
// "live".
export const TRANSFER_SEARCH_DEBOUNCE_MS = 500;

// Sentinel used by the filter UI to mean "no filter applied" for status / mode
// dropdowns. Stored as-is in reqData and stripped before going on the wire.
export const TRANSFER_FILTER_ALL = 'All';

// Max length for the user-supplied Reference ID on a Create Transfer
// request. Mirrors the backend column constraint — keeping it here so any
// future tweak is a single-file change.
export const TRANSFER_REFERENCE_ID_MAX_LENGTH = 64;